import React from "react";
import { ProductCard, ProductCardValue } from "@/features/product/ProductCard";
import { DrawerPageProps } from "../types";
import { DroppsProduct, productSelect, variantSelect } from "@/store";
import { ShopifyCartItem } from "@/services/shopifyCart";

type ProductSelectorPageProps = DrawerPageProps & {
  bundledProducts: DroppsProduct[];
  item: ShopifyCartItem;
};

export const BundleIncludesDrawer = ({
  bundledProducts,
  item,
}: ProductSelectorPageProps) => {
  return (
    <div className="space-y-4 px-5 py-6">
      <h3 className="subtitle mb-4 text-base font-semibold">
        {item.handle.includes("bundle") ? "Bundle" : "Starter Kit"}
        &nbsp;Contains
      </h3>
      {bundledProducts.map((product) => {
        const isSub = !!(
          item.selling_plan_allocation && product.sellingPlans.length
        );
        const featuredImage = productSelect.featuredImage(product);
        const productCardProduct: ProductCardValue = {
          featuredImage: { ...featuredImage, src: featuredImage.url },
          size: variantSelect.sizeFormat(productSelect.defaultVariant(product)),
          title: product.title,
          price: undefined,
        };
        return (
          <ProductCard
            key={product.handle}
            className="-m-3"
            bordered
            hoverable={false}
            compact
            productCardValue={productCardProduct}
            isSubBadge={isSub}
          />
        );
      })}
    </div>
  );
};
